
<template>
  <div>
    <Form ref="editModel" :model="editModel" :label-width="110">
      <FormItem label="影像日期：">{{ editModel.imageDate }}</FormItem>
      <FormItem label="目录：">{{ editModel.imageDicPath }}</FormItem>
      <FormItem label="文件名称：">{{ editModel.imageFileName }}</FormItem>
      <FormItem label="ImageID：">{{ editModel.imageID }}</FormItem>
      <FormItem label="影像序号：">{{ editModel.imageNumber }}</FormItem>
      <FormItem label="相对路径：">
        <div>{{editModel.imageRelatePath}}</div>
      </FormItem>
      <FormItem label="影像路径：">{{ editModel.imageDicPath+'/'+editModel.imageRelatePath }}</FormItem>
      <FormItem label="影像时间：">{{ editModel.imageTime }}</FormItem>
      <FormItem label="关键影像标志：">{{ editModel.keyImage }}</FormItem>
      <!-- <FormItem label="LastUpdateDate：">{{ editModel.lastUpdateDate }}</FormItem> -->
      <FormItem label="机构编码：">{{ editModel.organCode }}</FormItem>
      <FormItem label="序列ID：">{{ editModel.seriesID }}</FormItem>
      <FormItem label="SERIESUID：">{{ editModel.seriesInstanceUID }}</FormItem>
      <FormItem label="序列编号">{{ editModel.seriesNumber }}</FormItem>
      <FormItem label="层厚：">{{ editModel.slicethickness }}</FormItem>
      <FormItem label="SOPClassUID：">{{ editModel.sOPClassUID }}</FormItem>
      <FormItem label="删除标记：">{{ editModel.sOPInstanceUID }}</FormItem>
      <FormItem label="STUDYID：">{{ editModel.studyID }}</FormItem>
      <FormItem label="STUDYUID：">{{ editModel.studyInstanceUID }}</FormItem>
      <FormItem label="窗位：">{{ editModel.winCenter }}</FormItem>
      <FormItem label="窗宽：">{{ editModel.winWide }}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>